import { Component, OnInit } from '@angular/core';
import { Observable, firstValueFrom, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-delivery-notice',
  templateUrl: './delivery-notice.component.html',
  styleUrl: './delivery-notice.component.css'
})
export class DeliveryNoticeComponent implements OnInit {
  private holidays: Set<string> = new Set();
  dispatchDateRange: string = '';
  constructor(private http: HttpClient) { }
  ngOnInit(): void {
    firstValueFrom(this.loadHolidays('IN', new Date().getFullYear()))
      .then(() =>
        firstValueFrom(this.loadHolidays('IN', new Date().getFullYear() + 1))
      )
      .then(() => console.log())
      .catch((err) => console.error());

    // Get dispatch date
    this.getDispatchDateRange().then((range) => {
      this.dispatchDateRange = range;
    });
  }
  private loadHolidays(countryCode: string, year: number): Observable<void> {
    const url = `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`;
    return this.http.get<any[]>(url).pipe(
      map((list) => {
        if (Array.isArray(list)) {
          list.forEach((h) => {
            if (h && h.date) this.holidays.add(h.date);
          });
        } else {

        }
      })
    );
  }

  private isHoliday(date: Date): boolean {
    const str = date.toISOString().split('T')[0];
    return this.holidays.has(str);
  }

  async getDispatchDateRange(): Promise<string> {
    if (this.holidays.size === 0) {
      await firstValueFrom(this.loadHolidays('IN', new Date().getFullYear()));
      await firstValueFrom(
        this.loadHolidays('IN', new Date().getFullYear() + 1)
      );
    }

    const today = new Date();

    const isNonWorkingDay = (date: Date): boolean => {
      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;
      const isHoliday = this.isHoliday(date);
      return isWeekend || isHoliday;
    };

    const addWorkingDays = (date: Date, days: number): Date => {
      const result = new Date(date);
      while (days > 0) {
        result.setDate(result.getDate() + 1);
        if (!isNonWorkingDay(result)) days--;
      }
      return result;
    };

    const startDate = addWorkingDays(today, 5);
    const endDate = addWorkingDays(today, 7);

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
    };

    return `${startDate.toLocaleDateString(
      'en-US',
      options
    )} to ${endDate.toLocaleDateString('en-US', options)}`;
  }
}
